import { PageHeader } from '@/ui'
import { DeskControlsCard, DeskHealthPanel, DeskStatsPanel } from './DeskPanels'

/** /redeem/desk: is the handout desk healthy, its pause switch and blocklist,
 *  and its numbers. */
export default function Desk() {
  return (
    <>
      <PageHeader title="데스크" description="요청을 읽고 코드를 내보내는 자동 처리." />
      <div className="space-y-6">
        <DeskHealthPanel />
        <DeskControlsCard />
        <DeskStatsPanel chart />
      </div>
    </>
  )
}
